import type { Document } from 'state/__generated__/tadaahAPI';
import { useApiDiplomasList } from 'state/__generated__/tadaahAPI';
import useIsFreelancerLoggedIn from 'hooks/use-is-freelancer-logged-in';

type UseGetFreelancerDiplomaDocuments = {
  data: Document[] | undefined;
  error: string | undefined;
  isLoading: boolean;
};

const useGetFreelancerDocuments = (): UseGetFreelancerDiplomaDocuments => {
  const isLoggedIn = useIsFreelancerLoggedIn();

  const { data, error, isLoading } = useApiDiplomasList({
    query: {
      enabled: isLoggedIn,
      queryKey: ['freelancer-documents'],
    },
  });

  return { data: data?.data, error: error?.message, isLoading };
};

export default useGetFreelancerDocuments;
